import React from 'react';

const TemplateSettings = ({
  editingTemplate,
  updateGlobalSetting,
  resetAllFontsToGlobal,
}) => (
  <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
    <span style={{ fontSize: '11px', fontWeight: 600, color: 'var(--text-secondary)', whiteSpace: 'nowrap' }}>
      Czcionka:
    </span>
    <select
      value={editingTemplate?.config?.settings?.font_family || 'Arial'}
      onChange={(e) => updateGlobalSetting('font_family', e.target.value)}
      style={{ padding: '3px 6px', border: '1px solid var(--border)', borderRadius: '3px', fontSize: '11px' }}
    >
      <option value="Arial">Arial</option>
      <option value="Helvetica">Helvetica</option>
      <option value="DejaVuSans">DejaVu Sans (polskie znaki)</option>
      <option value="SystemUTF8">System UTF-8</option>
    </select>

    <span style={{ fontSize: '11px', fontWeight: 600, color: 'var(--text-secondary)', whiteSpace: 'nowrap' }}>
      Rozmiar:
    </span>
    <input
      type="number"
      min="6"
      max="72"
      value={editingTemplate?.config?.settings?.font_size || 10}
      onChange={(e) => updateGlobalSetting('font_size', parseInt(e.target.value) || 10)}
      style={{ width: '45px', padding: '3px 4px', border: '1px solid var(--border)', borderRadius: '3px', fontSize: '11px', textAlign: 'center' }}
    />

    <span style={{ fontSize: '11px', fontWeight: 600, color: 'var(--text-secondary)', whiteSpace: 'nowrap' }}>
      Styl:
    </span>
    <select
      value={editingTemplate?.config?.settings?.text_case || 'normal'}
      onChange={(e) => updateGlobalSetting('text_case', e.target.value)}
      style={{ padding: '3px 6px', border: '1px solid var(--border)', borderRadius: '3px', fontSize: '11px' }}
    >
      <option value="normal">Normalny</option>
      <option value="uppercase">WIELKIE</option>
      <option value="lowercase">małe</option>
      <option value="capitalize">Pierwsza Wielka</option>
    </select>

    <span style={{ fontSize: '11px', fontWeight: 600, color: 'var(--text-secondary)', whiteSpace: 'nowrap' }}>
      Strona:
    </span>
    <select
      value={editingTemplate?.config?.settings?.page_size || 'A4'}
      onChange={(e) => updateGlobalSetting('page_size', e.target.value)}
      style={{ padding: '3px 6px', border: '1px solid var(--border)', borderRadius: '3px', fontSize: '11px' }}
    >
      <option value="A4">A4</option>
      <option value="A5">A5</option>
      <option value="LETTER">Letter</option>
    </select>

    <button
      onClick={resetAllFontsToGlobal}
      style={{
        marginLeft: 'auto',
        padding: '4px 10px',
        fontSize: '11px',
        border: '1px solid var(--border)',
        backgroundColor: 'var(--card-bg)',
        color: 'var(--text-muted)',
        cursor: 'pointer',
        whiteSpace: 'nowrap',
      }}
      title="Usuwa indywidualne ustawienia czcionek z pól i wymusza globalne"
    >
      Reset czcionek
    </button>
  </div>
);

export default TemplateSettings;
